import React from 'react';
import { Toolbar, IconButton, Typography, TextField, InputAdornment, Box } from '@mui/material';
import { Menu as MenuIcon, AddCircle as AddCircleIcon, Search as SearchIcon } from '@mui/icons-material';
import clsx from 'clsx';
import { useStore } from 'react-redux';
import { useHistory } from 'react-router-dom';
import CurrentBalance from './merchant/dashboard/currentBalance';
import PaymentsCart from '../fields/navbar.payments-cart';
import ProfileMenu from '../fields/navbar.profile-menu';

function MenuToggle({ open }: { open?: boolean }) {
  const store = useStore();

  return (
    <div className={clsx(open && 'hidden')}>
      <IconButton
        edge="start"
        color="inherit"
        aria-label="open drawer"
        onClick={() => {
          store.dispatch({ type: 'TOGGLE_SIDEBAR' });
        }}
        className="mr-4"
        size="medium"
      >
        <MenuIcon />
      </IconButton>
    </div>
  );
}

function MerchantToolbar({ history, open }: any) {
  return (
    <Toolbar className="flex justify-between items-center px-6 bg-indigo-800">
      <MenuToggle open={open} />
      <Typography component="h1" variant="h6" color="inherit" noWrap className="flex-grow hidden sm:block">
        <TextField
          name="search"
          variant="outlined"
          size="small"
          className="bg-white rounded-xl"
          placeholder="Search..."
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              const searchText = (e.target as HTMLInputElement).value;
              history.push(`/dashboard/parcel?search=${encodeURIComponent(searchText)}`);
            }
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Typography>
      <div className="flex-grow sm:flex-grow-0">
        <CurrentBalance />
      </div>
      <IconButton
        onClick={() => {
          history.push('/dashboard/parcel/create');
        }}
        color="inherit"
      >
        <AddCircleIcon />
      </IconButton>
      <ProfileMenu history={history} />
    </Toolbar>
  );
}

function AdminToolbar({ history, open }: any) {
  return (
    <Toolbar className="flex justify-between items-center px-6 bg-indigo-800">
      <MenuToggle open={open} />
      <Typography component="h1" variant="h6" color="inherit" noWrap className="flex-grow">
        Dashboard
      </Typography>
      <IconButton
        onClick={() => {
          history.push('/dashboard/parcel/create');
        }}
        color="inherit"
      >
        <AddCircleIcon />
      </IconButton>
      <PaymentsCart history={history} />
      <ProfileMenu history={history} />
    </Toolbar>
  );
}

function RiderToolbar({ history, open }: any) {
  return (
    <Toolbar className="flex justify-between items-center px-6 bg-indigo-800">
      <MenuToggle open={open} />
      <Typography component="h1" variant="h6" color="inherit" noWrap className="flex-grow">
        Dashboard
      </Typography>
      <ProfileMenu history={history} />
    </Toolbar>
  );
}

export default function ToolBar({ open }: { open?: boolean }) {
  const store = useStore();
  const history = useHistory();

  const role = store.getState().auth.user.role.name;

  const ToolbarComponents: Record<string, React.FC<{ history: any; open?: boolean }>> = {
    merchant: MerchantToolbar,
    admin: AdminToolbar,
    rider: RiderToolbar,
  };

  const SelectedToolbar = ToolbarComponents[role] || null;

  return SelectedToolbar ? <SelectedToolbar history={history} open={open} /> : null;
}
